import { render, staticRenderFns } from "./GeoStudentStatus.vue?vue&type=template&id=5179a438&"
import script from "./GeoStudentStatus.vue?vue&type=script&lang=js&"
export * from "./GeoStudentStatus.vue?vue&type=script&lang=js&"
import style0 from "./GeoStudentStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports